// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hY-2","col":"styles_col__1ogOF","actions":"styles_actions__2zJ62","conflict":"styles_conflict__8VV_U"};